import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "js-cookie";
import { Link, useHistory } from "react-router-dom";
import { useDashboard } from "../contexts/DashboardContext";
import "../App.css";

const AddSystem = () => {
  let history = useHistory();
  let token = Cookies.get("token");
  let customerid = Cookies.get("customerid");

  const { customerInfo, setCustomerInfo } = useDashboard();

  const [activeTab, setActiveTab] = useState("add"); // add | existing
  const [type, setType] = useState("");
  const [licenseList, setLicenseList] = useState([]);
  const [serials, setSerials] = useState([]);
  const [selectedSystem, setSelectedSystem] = useState(null);
  const [credentials, setCredentials] = useState({ serial: "" });
  const [error, setError] = useState("");

  const downloadKeyFile = async (system) => {
    try {
      const kernelNameRes = await axios.get(
        `/api/License/name/${system.distributor_type}`,
        { headers: { "x-auth-token": token } },
      );

      const license = customerInfo?.find(
        (c) => c.name === kernelNameRes.data.name,
      );
      const expiryDate = license?.expiry || "perpetual";

      const content = `CHESS Security Platform V0.1
${kernelNameRes.data.name}
${system.machine_id}
${expiryDate}`;

      const licenseType = "system";

      const res = await axios.post(
        "/api/license/encrypt",
        {
          content,
          filename: `chess.lic`,
          licenseType,
        },
        {
          headers: { "x-auth-token": token },
          responseType: "blob",
        },
      );

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = `chess.lic`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Failed to download license", err);
    }
  };

  // ---------------- ADD SYSTEM ----------------

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    try {
      // Step 1: Add system
      const res = await axios.post(
        "/api/system",
        {
          customerid,
          machineid: credentials.serial,
          distributortype: type,
          location: "location",
          features: "features",
          isInsert: "true",
        },
        { headers: { "x-auth-token": token } },
      );

      // Step 2: Check if system already exists
      if (res.data.message === "System already exist") {
        setError(res.data.message); // Show backend message
        setTimeout(() => setError(""), 1000);
        return; // Stop execution, do NOT proceed to add serial
      }

      // Step 3: Add serial for new system
      await axios.post(
        "/api/system/addserial",
        {
          system_id: res.data.systemid,
          customer_id: customerid,
          machine_id: credentials.serial,
          features: "features",
          location: "location",
          distributor_type: type,
        },
        { headers: { "x-auth-token": token } },
      );

      // Step 4: Clear input, refresh serials, redirect
      setCredentials({ serial: "" });
      fetchSerials();
      history.push("/dashboard");
    } catch (err) {
      // Show generic error for other failures
      setError("Invalid data");
      setTimeout(() => setError(""), 1000);
    }
  };

  function getNameByType(type) {
    return licenseList.find((item) => item.type === type)?.name;
  }

  // ---------------- FETCH EXISTING SYSTEMS ----------------

  const fetchSerials = () => {
    axios
      .get(`/api/system/serial/${customerid}`, {
        headers: { "x-auth-token": token },
      })
      .then((res) => setSerials(res.data.data))
      .catch((err) => console.error(err));
  };

  useEffect(() => {
    if (!token) {
      history.push("/");
      return;
    } else {
      if (customerInfo.length > 0) return;
      axios
        .get(`/api/customer/${customerid}`, {
          headers: { "x-auth-token": token },
        })
        .then((res) => {
          setCustomerInfo(res.data.customers);
        })
        .catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    if (!token) {
      history.push("/");
      return;
    }
    fetchSerials();
    setLicenseList(customerInfo.map(({ name, type }) => ({ name, type })));
  }, [customerInfo]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      <div className="addcustomer" style={{ marginLeft: "25vw" }}>
        <Link
          to="/dashboard"
          style={{
            marginRight: "20px",
            textDecoration: "none",
            color: "#16e36e",
          }}
        >
          ← Back to Dashboard
        </Link>

        <h2>License Management</h2>

        {/* -------- Tabs -------- */}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <button
            className="btn"
            style={{
              background: activeTab === "add" ? "#007bff" : "grey",
              marginRight: "10px",
              fontWeight: "bold",
            }}
            onClick={() => setActiveTab("add")}
          >
            Add New System
          </button>
          <button
            className="btn"
            style={{
              background: activeTab === "existing" ? "#007bff" : "grey",
              fontWeight: "bold",
            }}
            onClick={() => setActiveTab("existing")}
          >
            Generate Key for Existing System
          </button>
        </div>

        {/* -------- ADD SYSTEM TAB -------- */}
        {activeTab === "add" && (
          <form onSubmit={handleSubmit}>
            <select
              className="license"
              value={type}
              onChange={(e) => setType(e.target.value)}
            >
              <option value="">Select License</option>
              {licenseList.map((license, i) => (
                <option key={i} value={license.type}>
                  {license.name}
                </option>
              ))}
            </select>

            <input
              type="text"
              placeholder="Enter Serial Number"
              name="serial"
              value={credentials.serial}
              onChange={(e) => setCredentials({ serial: e.target.value })}
              required
            />

            <br />
            {error}
            <br />

            <Link to="/dashboard">
              <button
                type="button"
                className="btn"
                style={{ float: "left", background: "grey" }}
              >
                Cancel
              </button>
            </Link>

            <button type="submit" className="btn" style={{ float: "right" }}>
              Add System
            </button>
          </form>
        )}

        {/* -------- EXISTING SYSTEMS TAB -------- */}
        {activeTab === "existing" && (
          <>
            <select
              className="license"
              value={selectedSystem ? selectedSystem.system_id : ""}
              onChange={(e) => {
                const system = serials.find(
                  (s) => s.system_id === e.target.value,
                );
                setSelectedSystem(system);
              }}
            >
              <option value="">Select Machine ID</option>
              {serials.map((s) => (
                <option key={s.system_id} value={s.system_id}>
                  {s.machine_id} ({getNameByType(s.distributor_type)})
                </option>
              ))}
            </select>

            <br />

            {selectedSystem && (
              <div
                style={{
                  marginTop: "20px",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <button
                  className="btn"
                  onClick={() => downloadKeyFile(selectedSystem)}
                >
                  Download License Key
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default AddSystem;
